import { combineReducers } from 'redux';
import { bindEntityScaffold, makeReducerFromScaffold } from '@classpass/saga-tools';

import * as entities from './entities';

const bindForReducer = name => bindEntityScaffold(entities[name], state => state.entities[name]);

export const activityTagTree = bindForReducer('activityTagTree');
export const blockOffTime = bindForReducer('blockOffTime');
export const calendarAvailability = bindForReducer('calendarAvailability');
export const calendarConfigurationPlatforms = bindForReducer('calendarConfigurationPlatforms');
export const classDetail = bindForReducer('classDetail');
export const classesRatings = bindForReducer('classesRatings');
export const classtivitySchedules = bindForReducer('classtivitySchedules');
export const cmsLegalContent = bindForReducer('cmsLegalContent');
export const connectCredentials = bindForReducer('connectCredentials');
export const conversationLimitStatus = bindForReducer('conversationLimitStatus');
export const dynamicPricingControls = bindForReducer('dynamicPricingControls');
export const excessInventory = bindForReducer('excessInventory');
export const googleCalendars = bindForReducer('googleCalendars');
export const instructorCalendars = bindForReducer('instructorCalendars');
export const instructorData = bindForReducer('instructorData');
export const instructorsData = bindForReducer('instructorsData');
export const instructorsRatings = bindForReducer('instructorsRatings');
export const logOut = bindForReducer('logOut');
export const messageUser = bindForReducer('messageUser');
export const msInventoryChangelog = bindForReducer('msInventoryChangelog');
export const msInventoryVenues = bindForReducer('msInventoryVenues');
export const opportunityRejectTracking = bindForReducer('opportunityRejectTracking');

export const payoutDetails = bindForReducer('payoutDetails');
export const payoutReports = bindForReducer('payoutReports');
export const payoutInvoiceStatus = bindForReducer('payoutInvoiceStatus');
export const practitioners = bindForReducer('practitioners');
export const premiumCaps = bindForReducer('premiumCaps');
export const campaigns = bindForReducer('campaigns');
export const ratingsClasses = bindForReducer('ratingsClasses');
export const ratingsInstructors = bindForReducer('ratingsInstructors');
export const recommendations = bindForReducer('recommendations');
export const reportsCampaigns = bindForReducer('reportsCampaigns');
export const reportsReservations = bindForReducer('reportsReservations');
export const reportsSchedule = bindForReducer('reportsSchedule');
export const reportsSchedules = bindForReducer('reportsSchedules');
export const reportsTransactions = bindForReducer('reportsTransactions');
export const reportsVenuesBookings = bindForReducer('reportsVenuesBookings');
export const reportsVenuesRevenue = bindForReducer('reportsVenuesRevenue');
export const resources = bindForReducer('resources');
export const reviewsData = bindForReducer('reviewsData');
export const reviewsStatistics = bindForReducer('reviewsStatistics');
export const roster = bindForReducer('roster');
export const scheduleClass = bindForReducer('scheduleClass');
export const scheduleIncrements = bindForReducer('scheduleIncrements');
export const scheduleData = bindForReducer('scheduleData');
export const scheduleInsights = bindForReducer('scheduleInsights');
export const scheduleInstance = bindForReducer('scheduleInstance');
export const schedulesClasses = bindForReducer('schedulesClasses');
export const schedulesData = bindForReducer('schedulesData');
export const schedulesInstances = bindForReducer('schedulesInstances');
export const services = bindForReducer('services');
export const staffAccounts = bindForReducer('staffAccounts');
export const staffAndEquipment = bindForReducer('staffAndEquipment');
export const statsInsightsModule = bindForReducer('statsInsightsModule');
export const statsMarketInsightsModulesList = bindForReducer('statsMarketInsightsModulesList');
export const statsYourInsightsModulesList = bindForReducer('statsYourInsightsModulesList');
export const statsReportsReservations = bindForReducer('statsReportsReservations');
export const statsReportsRevenue = bindForReducer('statsReportsRevenue');
export const upcomingSpotsAndBookings = bindForReducer('upcomingSpotsAndBookings');
export const updateLocale = bindForReducer('updateLocale');
export const updatePassword = bindForReducer('updatePassword');
export const userInfo = bindForReducer('userInfo');
export const userInsights = bindForReducer('userInsights');
export const userInsightsGraph = bindForReducer('userInsightsGraph');
export const userSettings = bindForReducer('userSettings');
export const userSmsSubscriptionStatus = bindForReducer('userSmsSubscriptionStatus');
export const venueClasses = bindForReducer('venueClasses');
export const venueDetails = bindForReducer('venueDetails');
export const venueDisabledTimeWindows = bindForReducer('venueDisabledTimeWindows');
export const venueEnabledClasses = bindForReducer('venueEnabledClasses');
export const venueInstructors = bindForReducer('venueInstructors');
export const venueOpportunities = bindForReducer('venueOpportunities');
export const venuePageAdditionalPhotos = bindForReducer('venuePageAdditionalPhotos');
export const venueSmartSpotOpportunities = bindForReducer('venueSmartSpotOpportunities');
export const venueSmartSpotBatchUpdate = bindForReducer('venueSmartSpotBatchUpdate');
export const venueSmartSpotSingleUpdate = bindForReducer('venueSmartSpotSingleUpdate');
export const venuePagePhotos = bindForReducer('venuePagePhotos');
export const venueSmartspotData = bindForReducer('venueSmartspotData');
export const waivers = bindForReducer('waivers');
export const venueVideos = bindForReducer('venueVideos');
export const brazeData = bindForReducer('brazeData');

export default combineReducers(
  Object.keys(entities).reduce((memo, key) => ({ ...memo, [key]: makeReducerFromScaffold(entities[key]) }), {})
);
